import { Button } from '@medly-components/core';
import styled from 'styled-components';

export const ClearButtonStyled = styled(Button).attrs({ variant: 'flat', hideUnderline: true })`
    width: 100%;
    padding: 0.8rem 1.4rem 0 0;
    justify-content: end;
`;
